export const en_54 = { 
    "common": {
        "pay": "REDEEM CODE",
    },
    "send_balance": {
        "enter_reward_code" : "Enter Pin Code",
        "store_pin_payment_msg" :"Please click \"redeem code\" below to complete the transaction. Once transaction is completed, an email will be sent to you with the receipt.",
        "reward_code_applied": "Pin Code Applied",
    }
}